// src/components/Header.js
import React from 'react';
import { Box, Typography, Button, Select, Option } from '@mui/joy';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'pl', label: '🇵🇱 Polski' },
  { code: 'en', label: '🇬🇧 English' },
  { code: 'de', label: '🇩🇪 Deutsch' },
  { code: 'fr', label: '🇫🇷 Français' },
  { code: 'es', label: '🇪🇸 Español' },
  { code: 'it', label: '🇮🇹 Italiano' },
  { code: 'pt', label: '🇵🇹 Português' },
  { code: 'ru', label: '🇷🇺 Русский' },
  { code: 'uk', label: '🇺🇦 Українська' },
];


const Header = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
 const lang = i18n.language || 'en';
  const handleLangChange = (e, value) => {
    if (value) i18n.changeLanguage(value);
  };

  return (
    <Box
      component="header"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: { xs: 2, sm: 4 },
        py: 2,
        background: 'linear-gradient(to right, #fce4ec, #d0eaff)',
        borderBottom: '1px solid #ddd',
      }}
    >
      <Typography
        level="h4"
        component={RouterLink}
        to="/"
        sx={{
          color: '#2d3c88',
          fontWeight: 'bold',
          textDecoration: 'none',
          cursor: 'pointer',
          transition: 'color 0.2s',
          '&:hover': {
            color: '#1976d2',
            textDecoration: 'underline',
          },
        }}
      >
        {t('header.title')}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {/* Język */}
        <Select
          size="sm"
          variant="soft"
          value={i18n.language}
          onChange={handleLangChange}
          sx={{ minWidth: 96, mr: 1 }}
        >
          {LANGS.map((lang) => (
            <Option key={lang.code} value={lang.code}>
              {lang.label}
            </Option>
          ))}
        </Select>

        <Button
          size="md"
          color="primary"
          onClick={() => navigate(`/${lang}/create`)}
          sx={{ borderRadius: '12px', fontWeight: 600 }}
        >
          {t('header.createEvent')}
        </Button>
      </Box>
    </Box>
  );
};

export default Header;
